import {Pipe, PipeTransform} from '@angular/core';
import {parseExternalUrl} from "@core/shared/utils/url";

@Pipe({
    name: 'externalUrl',
    standalone: false
})
export class ExternalUrlPipe implements PipeTransform {

    transform(value: string): string {

        return parseExternalUrl(value);
    }
}
